package com.gsb.vyapar.bhagya.datasource.network.request

import kotlinx.serialization.Serializable

@Serializable
data class AuthRequest(
    val returnSecureToken: Boolean? = null,
)